module.exports = __webpack_public_path__ + "static/media/nursingliquid.7df24636.png";